<template>
  <div class="home home-p-color min-container">
    <div class="banner min-container">
      <!-- <a :style="style" class="banner_img"></a> -->
      <div class="container">
        <div class="buy_easy">
          <!-- <div class="buy_easy_bg"></div> -->
          <p>EASY STEPS</p>
        </div>
        <div class="banner_body">
          <div class="banner_body_item" style="padding-right:60px">
            <p class="item_title">Select</p>
            <p>Select the Game Items that you want to purchase</p>
          </div>
          <div class="banner_body_item"  style="padding-right:58px">
            <p class="item_title">Checkout</p>
            <p>Pay for your Game Items with a credit card, debit card or E-wallet</p>
          </div>
          <div class="banner_body_item">
            <p class="item_title">Collect</p>
            <p>Game items will be credited to your in-app mailbox automatically after payment is complete</p>
          </div>
        </div>
      </div>
    </div>
    <div class="poker min-container">
      <div class="container">
        <p class="title center">
          OUR OFFERINGS
        </p>
        <div class="poker-con">
          <div class="center">
            <div class="poker-item" style="left:90px;" @click="toShop">
              <h3 class="normal"><span class="dollar" style="left:30px;">$</span>9.99</h3>
              <div class="diamond">
                <span class="coin" style="left: 50px;">10 Cr</span>
              </div>
            </div>
            <div class="poker-item" style="left:10px;" @click="toShop">
              <h3 class="normal"><span class="dollar" style="left:0px;">$</span>499.99</h3>
              <div class="diamond">
                  <span class="coin">500 Cr</span>
              </div>

              <!-- <h3 class="normal"><span class="dollar" style="left:15px;">$</span>99.99</h3>
              <div class="diamond">
                 <span class="coin">100 Cr</span>
              </div> -->
            </div>
            <div class="poker-item" style="left:-70px;" @click="toShop">
              <h3 class="normal"><span class="dollar" style="left:0px;">$</span>999.99</h3>
              <div class="diamond">
                  <span class="coin" style="left: 35px;">1000 Cr</span>
              </div>
            </div>
            <div class="poker-item"  style="left:-158px;" @click="toShop">
              <h3 class="normal"><span class="dollar" style="left:0px;">$</span>2500.00</h3>
              <div class="diamond"  style="left:24px;">
                 <span class="coin">2500 Cr</span>
              </div>
            </div>
          </div>
          <!-- <div>
            <p class="title_p">
              Playing on a third-party gaming platform is for entertainment purposes only, with no possibility for cash or other real-world value to be earned or withdrawn in any form.
            </p>
          </div> -->
        </div>
      </div>
    </div>
    <div class="club min-container">
      <div class="container">
        <p class="title center">
          WHAT CAN WE OFFER YOU?
        </p>

        <div class="club_item">
          <div class="club_item_left">
            <p class="title_p">Lowest Prices Online</p>
            <p>Mvpstore strives to provide our customers with the lowest prices anywhere on the internet for game items.</p>
          </div>

          <div class="club_item_right">
            <p class="title_p">Multiple Payment Methods</p>
            <p>Mvpstore offers players a variety of payment options including credit card, debit card and E-wallet.</p>
          </div>
        </div>
        <div class="club_item">
          <div class="club_item_left">
            <p class="title_p">Instant Access</p>
            <p>Game items will be credited to your in-app mailbox automatically within minutes after completing payment.</p>
          </div>
          <div class="club_item_right">
            <p class="title_p">Secure Ordering</p>
            <p>All orders on Mvpstore are processed securely</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      style: {}
    }
  },
  created () {
    this.$store.commit('changeTab', '/home')
    // this.initData()
    // this.PC_VERSON = PC_VERSON
    // this.FB_VERSON = FB_VERSON
    this.style = {
      backgroundImage: "url('/pc/static/img/hom/top_pro.png')"
    }
  },
  methods: {
    toShop () {
      window.location.href = '/shop'
    }
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 0px 0px 0px 0px;
  // margin-top: -91px;
  .banner {
    position: relative;
    height: 772px;
    width: 100%;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: auto 100%;
    background-image: url('/pc/static/img/hom/home_bg01.jpg');
    .slider-img {
      height: 771px;
    }
    .buy_easy {
      position: absolute;
      width: 360px;
      margin-left: -180px;
      height: 70px;
      left: 50%;
      top: 90px;
      .buy_easy_bg {
        position: absolute;
        width: 100%;
        height: 50%;
        top: 50%;
        left: 0px;
        background-color: #3e6aff;
      }
      p {
        line-height: 70px;
        font-size: 48px;
        font-weight: 700;
        position: relative;
        text-align: center;
        color: #ffffff;
      }
    }
    .banner_body {
      position: absolute;
      left: 50%;
      margin-left: -590px;
      top: 420px;
      width: 1180px;
      height: 150px;
      text-align: left;
      .banner_body_item {
        width: 30%;
        height: 100%;
        display: inline-block;
        vertical-align: top;
        .item_title {
          font-size: 24px;
          color: #ffffff;
          font-weight: 700;
          margin-bottom: 23px;
        }
        p {
          padding: 0px 35px;
          color: #ffffff;
        }
      }
    }
  }
  .poker {
    position: relative;
    width: 100%;
    height: 740px;
    background-image: url(/pc/static/img/hom/home_bg02.jpg);
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center top;
    padding: 80px 0px 0px 0px;
    .title_p {
      font-size:16.5px;
      line-height: 50px;
      color: #141a38;
      padding:10px;
      text-align: center;
    }
    .title {
      font-size: 44px;
      line-height: 50px;
      font-weight: 700;
      margin-top: 14px;
      color: #ffffff;
      img {
        display: inline-block;
        margin: 0px 10px;
      }
    }
    .poker-con {
      position: relative;
      top: 300px;
      .center {
        display: flex;
        justify-content: space-between;
      }
      .poker-item {
        position: relative;
        width: 200px;
        height: 179px;
        bottom: 30px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        h3 {
          font-size: 55px;
          margin: 40px 0px 0px 20px;;
          line-height: 60px;
          font-weight: 700;
        }
        h3.normal {
          color: #fffdff;
        }
        .dollar {
          position: absolute;
          top: 30px;
          font-size: 40px;
          font-weight: 500;
        }
        .line-through {
          text-decoration: line-through;
        }
        .diamond {
          position: absolute;
          width: 180px;
          height: 73px;
          top: 120px;
          left: 15px;
          bottom: 0px;
          text-align: center;
          cursor: pointer;
          background-image: url(/pc/static/img/hom/button_money.png);
          background-repeat: no-repeat;
          background-size: 100% auto;
          &:hover{
            background-image: url(/pc/static/img/hom/button_money2.png);
            background-repeat: no-repeat;
            background-size: 100% auto;
          }
          .coin {
            position: absolute;
            top: 5px;
            left: 50px;
            font-size: 28px;
            font-weight: 500;
            color: #642104;
          }
        }
      }
    }
  }

  .background-div {
    position: relative;
    width: 100%;
    height: 10px;
    background-color: #9eb0f2;
  }

  .club {
    position: relative;
    padding: 100px 0px 60px 0px;
    height: 980px;
    width:100%;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center top;
    background-image: url('/pc/static/img/hom/home_bg03.jpg');
    .title {
      font-size: 44px;
      line-height: 50px;
      font-weight: 700;
      color: #141a38;
      img {
        display: inline-block;
        margin: 0px 10px;
      }
    }
    .club_item {
      position: relative;
      display: inline-block;
      width: 1100px;
      height: 300px;
      margin: 76px 0px 40px 30px;
      .club_item_left {
        position: absolute;
        top: 200px;
        width: 321px;
        margin-right: 120px;
        height: 124px;
        .title_p {
          font-size: 24px;
          color: #371515;
          margin-bottom: 10px;
          font-weight: 700;
        }
        p {
          font-size: 16px;
          color: #4a4242;
        }
      }
      .club_item_right {
        position: absolute;
        top:200px;
        left: 60%;
        margin-right: 80px;
        height: 200px;
        .title_p {
          font-size: 24px;
          color: #371515;
          margin-bottom: 10px;
          font-weight: 700;
        }
        p {
          font-size: 16px;
          color: #4a4242;
        }
      }
    }
  }
}
</style>
